import React from 'react';

import { CHART_COLORS, LEGEND } from '../utils';
import {
	LegendWrapper,
	LegendItem,
	LegendColor,
	LegendName,
} from './Legend.styles';

export const Legend = () => {
	return (
		<LegendWrapper>
			<LegendItem>
				<LegendColor color={CHART_COLORS.GREEN} />
				<LegendName>{LEGEND.GREEN}</LegendName>
			</LegendItem>
			<LegendItem>
				<LegendColor color={CHART_COLORS.RED} />
				<LegendName>{LEGEND.RED}</LegendName>
			</LegendItem>
		</LegendWrapper>
	);
};
